<header app-header appNarvarBgScroll appheaderSetActive></header>
<router-outlet></router-outlet>